module.exports = __webpack_public_path__ + "media/images/Eco-construction-405d76e65e8767b480465a08b54505a0.svg";